const download = (state = {
    filename: '',
    downloadPdfProgress: false,
    downloadPdfSrc: null,
    selectedChapters: []
  }, { type, payload }) => {
    switch(type) {
      case 'SHOW_PDF':
        return {
          ...state,
          downloadPdfExpanded: true,
          downloadFullPdf: payload
        }
      case 'HIDE_PDF':
        return {
          ...state,
          downloadPdfExpanded: false,
          downloadFullPdf: false
        }
      case 'PDF_SRC':
        return {
          ...state,
          downloadPdfSrc: payload.source
        }
      case 'SHOW_PDFPROGRESS':
        return {
          ...state,
          downloadPdfProgess: true
        }
      case 'HIDE_PDFPROGRESS':
        return {
          ...state,
          downloadPdfProgess: false
        }
      case 'CHAPTER_TO_PDF':
        let selectedChapters = state.selectedChapters;
        if (payload.toPdf && !selectedChapters.includes(payload.id)) {
          selectedChapters.push(payload.id);
        }
        else {
          const index = selectedChapters.indexOf(payload.id);
          if(index > 0) {
            selectedChapters.splice(index, 1);
          }
        }

        var newState = {
          ...state,
          downloadPdfSrc: payload.src,
          selectedChapters: selectedChapters
        }
        return newState;
      default: return state;
    }
  }
  
  module.exports = download;
  


// WEBPACK FOOTER //
// ./src/modules/download/downloadReducer.js